// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherOutlinedSvg from "@ant-design/icons-svg/es/asn/SwitcherOutlined";
import AntdIcon from '../components/AntdIcon';

var SwitcherOutlined = function SwitcherOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherOutlinedSvg
  }));
};

SwitcherOutlined.displayName = 'SwitcherOutlined';
export default React.forwardRef(SwitcherOutlined);